import Swiper, {Autoplay, Navigation} from 'swiper';

Swiper.use([Autoplay, Navigation]);

const className = '.projects-project-details-content-right__slider';

export default () => {
    let container = document.querySelector(className);
    if (container) {
        let projectsSlider = slider(container);
    }
}

let slider = (container) => {
    let swiperPrev = '.swiper-button-prev';
    let swiperNext = '.swiper-button-next';

    let swiper = new Swiper(container, {
        slidesPerView: 1,
        centeredSlides: true,
        navigation: {
            prevEl: swiperPrev,
            nextEl: swiperNext,
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
    });

    if (container.querySelectorAll('.swiper-slide').length < 2) {
        container.querySelector(swiperPrev).style.display = "none";
        container.querySelector(swiperNext).style.display = "none";
    }

    return swiper;
}
